import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import "./assets/scss/app.scss";
import "./initializers";

import VIcon from "@/components/VIcon.vue";
import Toasted from "vue-toasted";
import VueResource from "vue-resource";
import ActionCableVue from "actioncable-vue";
import { AUTH_ENDPOINT } from "@/constants";

Vue.config.productionTip = false;
Vue.component("v-icon", VIcon);
Vue.use(Toasted);
Vue.use(VueResource);
Vue.use(ActionCableVue, {
  debug: true,
  debugLevel: "all",
  connectionUrl: AUTH_ENDPOINT + "/cable",
  connectImmediately: false,
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
